import {IBizProfitSharing, IBusiness} from "@/views/editor/service/business";
import {AEditor} from "@/views/editor/service/editor";
import {IActivityBusinessMeta} from "@/model/activity";
import {CheckboxOptionType} from "ant-design-vue/es/checkbox/interface";
import {AProfitSharing} from "@/views/editor/service/profit_sharing/profit_sharing";
import {INotifyRole} from "@/views/editor/service/types";


export interface IProfitSharingMeta {
    distribution: {
        level_1_ratio: number[]
        level_2_ratio: number
        distributor_reg_require_sign: boolean
        subordinate_reg_required: 'view' | 'order' | 'pay'
        is_relationship_not_bind: boolean
        is_inviting_old_customers_without_commission: boolean
        tip_commission: number
    }
    invitation_leaderboard: {
        title: string
        is_virtual_list: boolean
        list: number[]
        is_show_commission_sum: boolean
        is_employee_on_board: boolean
    }
    cash_back: {
        ratio: number
    }
    employee_awards: {
        steps: { [key: number]: number[] }
        support_indirect: boolean;
        is_inviting_old_customers_without_commission: boolean;
        is_reject_distributor: boolean;
    }
}

export default class ProfitSharing extends AProfitSharing implements IBizProfitSharing {
    subs: CheckboxOptionType[] = [
        {value: 'distribution', label: '分销'},
        {value: 'employee', label: '内部成员奖'},
        {value: 'cash_back', label: '下单返现'}];
    readonly opt: IProfitSharingMeta

    constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
        this.opt = meta.setting as IProfitSharingMeta;
    }

    resetMeta(): IBusiness {
        this.meta.subs.length = 0
        this.meta.subs.push(...this.subs.map(s => s.value as string))
        Object.assign(this.opt, {
            cash_back: {enable: true, ratio: 0},
            distribution: {
                distributor_reg_require_sign: false,
                enable: true,
                is_inviting_old_customers_without_commission: false,
                is_relationship_not_bind: false,
                level_1_ratio: 0,
                level_2_ratio: 0,
                subordinate_reg_required: 'view',
                tip_commission: 0
            },
            employee_awards: {
                is_inviting_old_customers_without_commission: false,
                is_reject_distributor: false,
                steps: {0: [1, 2], 2: [2, 3]},
                support_indirect: false
            },
            invitation_leaderboard: {
                is_employee_on_board: false,
                is_show_commission_sum: false,
                is_virtual_list: false,
                list: [],
                title: ""
            }
        })
        return this;
    }

    roles(): INotifyRole[] {
        const arr: INotifyRole[] = [];
        if (this.meta.subs.includes('distribution')) arr.push(...[
            {
                name: '分销员',
                is_virtual: false,
                events: {
                    'pms.activity.business.profit_sharing.profit_sharing.distribution.sharing': '分账',
                    'pms.activity.business.profit_sharing.profit_sharing.distribution.sub.new': '新下级',
                },
                is_status_multiple: false,
                status: ['无下级', '有下级', '有佣金']
            },
            {
                name: '受邀人',
                is_virtual: false,
                events: {
                    'pms.activity.business.profit_sharing.profit_sharing.distribution.upgrade': '晋升',
                },
                is_status_multiple: false,
                status: []
            }
        ])
        return arr
    }
}